import { lazy } from "react";

// Route const
import { ROUTES_VAR, PERMISSIONS, ROUTE_NAME } from "shared/constants";

//details
import { PaymentView } from "pages/Payments/PaymentView";
import DepositView from "pages/Deposits/DepositView";
import SubuserPaymentView from "pages/SubuserPayments/SubuserPaymentView";
import Configurations from "pages/Configurations/configuration";
import plebgraphCongiguration from "pages/Configurations/plebgraphConfiguration";
// Pages
import AutoDisbursement from "pages/Purple/AutoDisbursement";
import OutbondPayment from "pages/Purple/OutbondPaymentDetails";
import PincodeList from "pages/ConfigurationMain/PincodeList";
import City from "pages/ConfigurationMain/City";
import MerchantOfferMap from "pages/Offer/merchantOfferMap";
import EmandateRegistration from "pages/EmandateStats/EmandateRegistration";
import StatisticsPayments from "pages/EmandateStats/StatisticsPayments";
import StatisticsRegistration from "pages/EmandateStats/StatisticsRegistration";
import MerchantOfferMapV2 from "pages/NewOffer/merchantOfferMapV2";

const State = lazy(() => import("pages/ConfigurationMain/State"));
const Transactions = lazy(() => import("pages/Transactions"));
const Transaction = lazy(() => import("pages/Transactions/Transaction"));
const UserListing = lazy(() => import("pages/UsersView/UserListing"));
const PaymentListing = lazy(() => import("pages/Payments/PaymentListing"));
const Loans = lazy(() => import("pages/Loans"));
const Loan = lazy(() => import("pages/Loans/Loan"));
const CustomerView = lazy(() => import("pages/UsersView/CustomerView"));
const TestingPanel = lazy(() => import("pages/TestingPanel/TestingPanel"));
const SignIn = lazy(() => import("pages/auth/SignIn"));
const Roles = lazy(() => import("pages/Roles"));
const Role = lazy(() => import("pages/Roles/Role"));
const Dashboard = lazy(() => import("pages/Dashboard"));
const UtrCheck = lazy(() => import("pages/UtrCheck"));
const RefundListing = lazy(() => import("pages/Refund"));
const RefundView = lazy(() => import("pages/Refund/RefundView"));
const Statistics = lazy(() => import("pages/Statistics"));
const FileUpload = lazy(() => import("pages/FileUpload"));
const Deposits = lazy(() => import("pages/Deposits"));
const SubuserPayments = lazy(() => import("pages/SubuserPayments"));
const Financier = lazy(() => import("pages/financier"));
const FinancierCustomerView = lazy(
  () => import("pages/financier/FinancierCustomerView"),
);
const SnoozedAllowed = lazy(() => import("pages/Snoozed/allowed"));
const SnoozedBlocked = lazy(() => import("pages/Snoozed/blocked"));
const DigiDataReport = lazy(() => import("pages/DigiReport"));
const DisburseSanity = lazy(() => import("pages/Purple/DisbursementSanity"));
const PennyDrop = lazy(() => import("pages/Purple/PennyDrop"));
const BlockedUsers = lazy(() => import("pages/Purple/BlockedUsers"));
const AllowRepeatDelinquent = lazy(
  () => import("pages/Purple/AllowRepeatDelinquent"),
);
const AllowRepeatDelinquentV2 = lazy(
  () => import("pages/Purple/AllowRepeatDelinquentV2"),
);
const DisbursementStatistic = lazy(
  () => import("pages/Purple/DisbursementStatistic"),
);
const PanNsdl = lazy(() => import("pages/Others/PanNSDl/PanNsdl"));
const BankListing = lazy(() => import("pages/Others/BankListing/index"));
const TransactionDenied = lazy(
  () => import("pages/Others/TransactionDenied/index"),
);
const userEdit = lazy(() => import("pages/UsersView/dialogs/UserEdit"));
const SplitPayment = lazy(() => import("pages/SplitPayment/index"));
const FinancierApproval = lazy(() => import("pages/FinancierApproval/index"));
const MerchantOffer = lazy(() => import("pages/Offer/MerchantOffer/index"));
const MerchantMainV2 = lazy(
  () => import("pages/NewOffer/MerchantOfferV2/index"),
);
const OfferMerchantAdd = lazy(
  () => import("pages/Offer/MerchantOffer/AddMerchant"),
);
const OfferMerchantAddV2 = lazy(
  () => import("pages/NewOffer/MerchantOfferV2/AddMerchant"),
);
const ViewOfferMap = lazy(
  () => import("pages/Offer/merchantOfferMap/ViewOfferMap/index"),
);
const ViewOfferMapV2 = lazy(
  () => import("pages/NewOffer/merchantOfferMapV2/ViewOfferMap/index"),
);
const AddMapModel = lazy(
  () => import("pages/Offer/merchantOfferMap/AddMapModel/index"),
);
const AddMapModelV2 = lazy(
  () => import("pages/NewOffer/merchantOfferMapV2/AddMapModel/index"),
);
const GBGrid = lazy(() => import("pages/Purple/GbGrid"));
const LoanMatrix = lazy(() => import("pages/Purple/LoanMatrix"));
const LoanMatrixV2 = lazy(() => import("pages/Purple/LoanMatrixV2"));
const LoanMatrixAdd = lazy(() => import("pages/Purple/LoanMatrix/AddTemplate"));
const LoanMatrixAddV2 = lazy(
  () => import("pages/Purple/LoanMatrixV2/AddTemplate"),
);
const LoanMatrixEdit = lazy(
  () => import("pages/Purple/LoanMatrix/EditTemplate"),
);
const LoanMatrixEditV2 = lazy(
  () => import("pages/Purple/LoanMatrixV2/EditTemplate"),
);
const LoanOfferView = lazy(() => import("pages/Purple/LoanMatrix/Offers"));
const LoanOfferViewV2 = lazy(() => import("pages/Purple/LoanMatrixV2/Offers"));
const Cibil = lazy(() => import("pages/Others/Cibil/index"));
const ViewCibil = lazy(() => import("pages/Others/Cibil/dialog/ViewCibil"));
const ViewResponse = lazy(
  () => import("pages/Others/Cibil/dialog/ViewResponse"),
);
const MerchantListing = lazy(() => import("pages/Merchant/Merchant List"));
const MerchantSettlement = lazy(
  () => import("pages/Merchant/merchantSettlement/index"),
);
const UserBankDetails = lazy(
  () => import("pages/Others/UserBankDetails/index"),
);
const AdminSubuser = lazy(() => import("pages/AdminSubuser/index"));
const ReportsData = lazy(() => import("pages/Others/ReportData/index"));
const ReportsDataV2 = lazy(() => import("pages/Others/ReportDataV2/index"));
const AddRoles = lazy(() => import("pages/Roles/AddRoles"));
const LoansnapShotUpload = lazy(
  () => import("pages/Others/LoansnapShotUpload"),
);
const DeleteDataRequest = lazy(() => import("pages/DeleteDataRequest/index"));
const CommunicatonUpload = lazy(
  () => import("pages/Others/CommunicationUpload"),
);
const PlebgraphGBGrid = lazy(() => import("pages/Purple/PlebgraphGbGrid"));
const CustomerNameMatch = lazy(
  () => import("pages/Others/CustomerNameMatch/index"),
);

export default [
  {
    path: ROUTES_VAR.signIn,
    exact: true,
    component: SignIn,
    sideDrawer: false,
    isPrivate: false,
    permission: PERMISSIONS.all,
    route: "",
  },
  {
    path: ROUTES_VAR.dashboard,
    exact: true,
    component: Dashboard,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.all,
    route: "/",
  },
  {
    path: ROUTES_VAR.statistics,
    exact: true,
    component: Statistics,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.statistics,
    permission: PERMISSIONS.statistics.view,
  },
  {
    path: ROUTES_VAR.loans,
    exact: true,
    component: Loans,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.loan.list,
    route: ROUTE_NAME.loan,
  },
  {
    path: ROUTES_VAR.loan,
    exact: true,
    component: Loan,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.loan.view,
    route: ROUTE_NAME.loan,
  },
  {
    path: ROUTES_VAR.users,
    exact: true,
    component: UserListing,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.user.list,
    route: ROUTE_NAME.user,
  },
  {
    path: ROUTES_VAR.user,
    exact: true,
    component: CustomerView,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.user.view,
    route: ROUTE_NAME.user,
  },
  {
    path: ROUTES_VAR.transactions,
    exact: true,
    component: Transactions,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.transaction.list,
    route: ROUTE_NAME.transaction,
  },
  {
    path: ROUTES_VAR.transaction,
    exact: true,
    component: Transaction,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.transaction.view,
    route: ROUTE_NAME.transaction,
  },

  {
    path: ROUTES_VAR.payments,
    exact: true,
    component: PaymentListing,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.payment.list,
    route: ROUTE_NAME.payment,
  },
  {
    path: ROUTES_VAR.splitpay_view,
    exact: true,
    component: SplitPayment,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.split_payments.list,
    route: ROUTE_NAME.split_payments,
  },
  {
    path: ROUTES_VAR.subuserPayments,
    exact: true,
    component: SubuserPayments,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.subuser_payment.list,
    route: ROUTE_NAME.subuser_payment,
  },
  {
    path: ROUTES_VAR.subuserPayments_view,
    exact: true,
    component: SubuserPaymentView,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.subuser_payment.list,
    route: ROUTE_NAME.subuser_payment,
  },
  {
    path: ROUTES_VAR.deposits,
    exact: true,
    component: Deposits,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.deposit.list,
    route: ROUTE_NAME.deposit,
  },

  {
    path: ROUTES_VAR.deposit_view,
    exact: true,
    component: DepositView,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.deposit.view,
    route: ROUTE_NAME.deposit,
  },
  {
    path: ROUTES_VAR.payment_view,
    exact: true,
    component: PaymentView,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.payment.view,
    route: ROUTE_NAME.payment,
  },
  {
    path: ROUTES_VAR.check_utr,
    exact: true,
    component: UtrCheck,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.check_utr.list,
    route: ROUTE_NAME.check_utr,
  },
  {
    path: ROUTES_VAR.refund,
    exact: true,
    component: RefundListing,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.refund.list,
    route: ROUTE_NAME.refund,
  },
  {
    path: ROUTES_VAR.refund_view,
    exact: true,
    component: RefundView,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.refund.view,
    route: ROUTE_NAME.refund,
  },
  {
    path: ROUTES_VAR.testing,
    exact: true,
    component: TestingPanel,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.testing,
    permission: PERMISSIONS.all,
  },
  {
    path: ROUTES_VAR.digi_report,
    exact: true,
    component: DigiDataReport,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.digi_data_report,
    permission: PERMISSIONS.digi_data_report.list,
  },
  {
    path: ROUTES_VAR.Pan_nsdl,
    exact: true,
    component: PanNsdl,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.pan_nsdl.pannsdl_list,
    route: ROUTE_NAME.pan_nsdl,
  },
  // {
  //   path: ROUTES_VAR.nach,
  //   exact: true,
  //   component: NachPresentation,
  //   isSideDrawer: true,
  //   isPrivate: true,
  //   route: ROUTE_NAME.nach,
  //   permission: PERMISSIONS.nach.list,
  // },
  // {
  //   path: ROUTES_VAR.mandateDetail,
  //   exact: true,
  //   component: NachDetails,
  //   isSideDrawer: true,
  //   isPrivate: true,
  //   route: ROUTE_NAME.nach,
  //   permission: PERMISSIONS.nach.details,
  // },
  // {
  //   path: ROUTES_VAR.mandate,
  //   exact: true,
  //   component: MandateListing,
  //   isSideDrawer: true,
  //   isPrivate: true,
  //   route: ROUTE_NAME.nach,
  //   permission: PERMISSIONS.nach.nachList,
  // },
  {
    path: ROUTES_VAR.snoozed_allowed,
    exact: true,
    component: SnoozedAllowed,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.snooze_allowed,
    permission: PERMISSIONS.snooze_allowed.list,
  },
  {
    path: ROUTES_VAR.snoozed_blocked,
    exact: true,
    component: SnoozedBlocked,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.snooze_blocked,
    permission: PERMISSIONS.snooze_blocked.list,
  },
  // {
  //   path: ROUTES_VAR.koino,
  //   exact: true,
  //   component: Koino,
  //   isSideDrawer: true,
  //   isPrivate: true,
  //   route: ROUTE_NAME.koino,
  //   permission: PERMISSIONS.koino.upload_transit_user,
  // },
  {
    path: ROUTES_VAR.financier,
    exact: true,
    component: Financier,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.financier,
    permission: PERMISSIONS.financiers.list,
  },
  {
    path: ROUTES_VAR.financier_view,
    exact: true,
    component: FinancierCustomerView,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.financier,
    permission: PERMISSIONS.financiers.view,
  },
  {
    path: ROUTES_VAR.financier,
    exact: true,
    component: Financier,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.financier,
    permission: PERMISSIONS.financiers.list,
  },
  // {
  //   path: ROUTES_VAR.reports,
  //   exact: true,
  //   component: Reports,
  //   isSideDrawer: true,
  //   isPrivate: true,
  //   route: ROUTE_NAME.reports,
  //   permission: PERMISSIONS.all,
  // },{
  //   path: ROUTES_VAR.vouchers,
  //   exact: true,
  //   component: Vouchers,
  //   isSideDrawer: true,
  //   isPrivate: true,
  //   route: ROUTE_NAME.voucher,
  //   permission: PERMISSIONS.all,
  // },
  // {
  //   path: ROUTES_VAR.transactions,
  //   exact: true,
  //   component: Transaction,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  // {
  //   path: ROUTES_VAR.docket_tracking_panel.link,
  //   exact: true,
  //   component: () => <div>Docket</div>,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  // {
  //   path: ROUTES_VAR.docket_tracking_panel.external_docket,
  //   exact: true,
  //   component: () => <div>Docket sub</div>,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  // {
  //   path: ROUTES_VAR.documentViewer,
  //   exact: true,
  //   component: () => <DocumentViewer />,
  //   isSideDrawer: false,
  //   isPrivate: true,
  // },
  {
    path: ROUTES_VAR.roles,
    exact: true,
    component: Roles,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.role.list,
    route: ROUTE_NAME.role,
  },
  {
    path: ROUTES_VAR.role_view,
    exact: true,
    component: Role,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.role.view,
    route: ROUTE_NAME.role,
  },
  {
    path: ROUTES_VAR.role_edit,
    exact: true,
    component: Role,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.role.update,
    route: ROUTE_NAME.role,
  },
  {
    path: ROUTES_VAR.fileUpload,
    exact: true,
    component: FileUpload,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.file_upload.list,
    route: ROUTE_NAME.file_upload,
  },
  {
    path: ROUTES_VAR.configuration,
    exact: true,
    component: Configurations,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.configuration.list,
    route: ROUTE_NAME.configuration,
  },
  {
    path: ROUTES_VAR.plebgraph_configuration,
    exact: true,
    component: plebgraphCongiguration,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.plebgraph_configuration.list,
    route: ROUTE_NAME.plebgraph_configuration,
  },
  {
    path: ROUTES_VAR.emandate_registration,
    exact: true,
    component: EmandateRegistration,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.emandate_registration.emandate_list,
    route: ROUTE_NAME.emandate_registration,
  },
  {
    path: ROUTES_VAR.statistics_registration,
    exact: true,
    component: StatisticsRegistration,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.emandate_registration.statistics_registration,
    route: ROUTE_NAME.emandate_registration,
  },
  {
    path: ROUTES_VAR.statistics_payments,
    exact: true,
    component: StatisticsPayments,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.emandate_registration.statistics_payments,
    route: ROUTE_NAME.emandate_registration,
  },
  {
    path: ROUTES_VAR.merchant_offer,
    exact: true,
    component: MerchantMainV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_offer.merchant_list,
    route: ROUTE_NAME.merchant_offer,
  },
  {
    path: ROUTES_VAR.offer_merchant_add,
    exact: true,
    component: OfferMerchantAddV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_offer.merchant_create,
    route: ROUTE_NAME.merchant_offer,
  },
  {
    path: ROUTES_VAR.dis_sanity_list,
    exact: true,
    component: DisburseSanity,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.disbursement_sanity.view,
    route: ROUTE_NAME.disbursement_sanity,
  },
  {
    path: ROUTES_VAR.penny_drop,
    exact: true,
    component: PennyDrop,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.penny_drop_sanity.list,
    route: ROUTE_NAME.penny_drop_sanity,
  },
  {
    path: ROUTES_VAR.blocked_users,
    exact: true,
    component: BlockedUsers,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.blocked_users.list,
    route: ROUTE_NAME.blocked_users,
  },
  {
    path: ROUTES_VAR.allow_repeat_delinquent,
    exact: true,
    component: AllowRepeatDelinquentV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.repeat_deliquent.list,
    route: ROUTE_NAME.repeat_deliquent,
  },
  {
    path: ROUTES_VAR.disbursement_statistics,
    exact: true,
    component: DisbursementStatistic,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.disbursement_statistic.view,
    route: ROUTE_NAME.disbursement_statistic,
  },
  {
    path: ROUTES_VAR.auto_disbursement,
    exact: true,
    component: AutoDisbursement,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.auto_disbursement.list,
    route: ROUTE_NAME.auto_disbursement,
  },
  {
    path: ROUTES_VAR.outbond_payment,
    exact: true,
    component: OutbondPayment,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.outbound_payment.list,
    route: ROUTE_NAME.outbound_payment,
  },
  {
    path: ROUTES_VAR.bank_listing,
    exact: true,
    component: BankListing,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.bank_list.list,
    route: ROUTE_NAME.bank_list,
  },
  {
    path: ROUTES_VAR.pincode_list,
    exact: true,
    component: PincodeList,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.pincode.pincode_list,
    route: ROUTE_NAME.pincode,
  },
  {
    path: ROUTES_VAR.state,
    exact: true,
    component: State,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.state.state_list,
    route: ROUTE_NAME.state,
  },
  {
    path: ROUTES_VAR.city,
    exact: true,
    component: City,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.city.city_list,
    route: ROUTE_NAME.city,
  },
  {
    path: ROUTES_VAR.transaction_denied,
    exact: true,
    component: TransactionDenied,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.upload_denied2_transactions.view,
    route: ROUTE_NAME.upload_denied2_transactions,
  },
  {
    path: ROUTES_VAR.user_edit,
    exact: true,
    component: userEdit,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.all,
    route: ROUTE_NAME.useredit,
  },
  {
    path: ROUTES_VAR.financier_approval,
    exact: true,
    component: FinancierApproval,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.financier_approval.list,
    route: ROUTE_NAME.financier_approval,
  },
  {
    path: ROUTES_VAR.merchant_offer,
    exact: true,
    component: MerchantOffer,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_offer.merchant_list,
    route: ROUTE_NAME.merchant_offer,
  },
  {
    path: ROUTES_VAR.offer_merchant_add,
    exact: true,
    component: OfferMerchantAdd,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_offer.merchant_create,
    route: ROUTE_NAME.merchant_offer,
  },
  {
    path: ROUTES_VAR.merchant_map,
    exact: true,
    component: MerchantOfferMapV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_offer_map.offer_map_list,
    route: ROUTE_NAME.merchant_offer_map,
  },
  {
    path: ROUTES_VAR.gb_grid,
    exact: true,
    component: GBGrid,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.gb_grid.list,
    route: ROUTE_NAME.gb_grid,
  },
  {
    path: ROUTES_VAR.plebgraph_gb_grid,
    exact: true,
    component: PlebgraphGBGrid,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.plebgraph_gb_grid.list,
    route: ROUTE_NAME.plebgraph_gb_grid,
  },
  {
    path: ROUTES_VAR.merchant_offer_map,
    exact: true,
    component: ViewOfferMapV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_offer_map.offer_map_view,
    route: ROUTE_NAME.merchant_offer_map,
  },
  {
    path: ROUTES_VAR.merchant_offer_map_edit,
    exact: true,
    component: AddMapModelV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_offer_map.offer_map_update,
    route: ROUTE_NAME.merchant_offer_map,
  },
  {
    path: ROUTES_VAR.merchant_offer_map_add,
    exact: true,
    component: AddMapModelV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_offer_map.offer_map_create,
    route: ROUTE_NAME.merchant_offer_map,
  },
  {
    path: ROUTES_VAR.loan_matrix,
    exact: true,
    component: LoanMatrixV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.loan_matrix.list,
    route: ROUTE_NAME.loan_matrix,
  },
  {
    path: ROUTES_VAR.loan_matrix_add,
    // exact: true,
    component: LoanMatrixAddV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.loan_matrix.create,
    route: ROUTE_NAME.loan_matrix,
  },
  {
    path: ROUTES_VAR.loan_matrix_edit,
    exact: true,
    component: LoanMatrixEditV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.loan_matrix.fresh_grid_update,
    route: ROUTE_NAME.loan_matrix,
    // permission: PERMISSIONS.state.state_list,
    // route: ROUTE_NAME.state,
  },
  {
    path: ROUTES_VAR.offers_page,
    exact: true,
    component: LoanOfferViewV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.all,
    route: ROUTE_NAME.offersPage,
  },
  {
    path: ROUTES_VAR.loansnapshot_upload,
    exact: true,
    component: LoansnapShotUpload,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.upload_loan_snapshot.view,
    route: ROUTE_NAME.upload_loan_snapshot,
  },
  {
    path: ROUTES_VAR.communication_upload,
    exact: true,
    component: CommunicatonUpload,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.communication_bulk_upload.view,
    route: ROUTE_NAME.communication_bulk_upload,
  },
  {
    path: ROUTES_VAR.cibil,
    exact: true,
    component: Cibil,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.cibil.list,
    route: ROUTE_NAME.cibil,
  },
  {
    path: ROUTES_VAR.View_cibil,
    exact: true,
    component: ViewCibil,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.cibil.view,
    route: ROUTE_NAME.cibil,
  },
  {
    path: ROUTES_VAR.View_response,
    exact: true,
    component: ViewResponse,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.cibil.view_response,
    route: ROUTE_NAME.cibil,
  },
  {
    path: ROUTES_VAR.user_bank_details,
    exact: true,
    component: UserBankDetails,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.user_bank_details.list,
    route: ROUTE_NAME.user_bank_details,
  },
  {
    path: ROUTES_VAR.customer_name_match,
    exact: true,
    component: CustomerNameMatch,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.name_match_review.list,
    route: ROUTE_NAME.name_match_review,
  },
  {
    path: ROUTES_VAR.add_roles,
    exact: true,
    component: AddRoles,
    isSideDrawer: true,
    isPrivate: true,
    route: ROUTE_NAME.role,
    permission: PERMISSIONS.role.create,
  },
  {
    path: ROUTES_VAR.admin_subuser,
    exact: true,
    component: AdminSubuser,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.subuser.list_name,
    route: ROUTE_NAME.subuser,
  },
  {
    path: ROUTES_VAR.merchant_list,
    exact: true,
    component: MerchantListing,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchants.list,
    route: ROUTE_NAME.merchants,
  },
  {
    path: ROUTES_VAR.merchantSettlement,
    exact: true,
    component: MerchantSettlement,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.merchant_settlement.list,
    route: ROUTE_NAME.merchant_settlement,
  },
  // {
  //   path: ROUTES_VAR.report_data,
  //   exact: true,
  //   component: ReportsData,
  //   isSideDrawer: true,
  //   isPrivate: true,
  //   permission: PERMISSIONS.report_data.report_list,
  //   route: ROUTE_NAME.report_data,
  // },
  {
    path: ROUTES_VAR.report_data,
    exact: true,
    component: ReportsDataV2,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.report_data.report_list,
    route: ROUTE_NAME.report_data,
  },
  // {
  //   path: ROUTES_VAR.payment.link,
  //   exact: true,
  //   component: () => <div>Payment</div>,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  // {
  //   path: ROUTES_VAR.payment.payment,
  //   exact: true,
  //   component: () => <div>Payment sub</div>,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  // {
  //   path: ROUTES_VAR.payment.payment_view,
  //   exact: true,
  //   component: () => <div>Payment view</div>,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  // {
  //   path: ROUTES_VAR.payment.razorpay,
  //   exact: true,
  //   component: () => <div>razor</div>,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  // {
  //   path: ROUTES_VAR.payment.payu,
  //   exact: true,
  //   component: () => <div>payu</div>,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  // {
  //   path: ROUTES_VAR.payment.paytm,
  //   exact: true,
  //   component: () => <div>paytm</div>,
  //   isSideDrawer: true,
  //   isPrivate: true,
  // },
  {
    path: ROUTES_VAR.delete_data_request,
    exact: true,
    component: DeleteDataRequest,
    isSideDrawer: true,
    isPrivate: true,
    permission: PERMISSIONS.delete_account.list,
    route: ROUTE_NAME.delete_account,
  },
];
